import { useMutation } from "@tanstack/react-query";

import { uploadPhotoID } from "../queryFunctions/uploadPhotoID";

export function useUploadPhotoID() {
  return useMutation({
    mutationFn: uploadPhotoID,
  });
}
